import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import SolutionMarketplaceFeatures from "./SolutionMarketplaceFeatures";
import SolutionMarketplacebenefits from "./SolutionMarketplacebenefits";
import "./SolutionMarketplace.css";
// Main component for PointSolution Marketplace
export default function PointSolution() {
  // Overview Data containing different stack solutions
  const data1 = [
    // EdgeStack processes data locally, reducing latency and bandwidth usage.
    "ABN Network: ABN is a blockchain-enabled online community for agribusiness that facilitates transparent, secure, and efficient trade of raw, semi-processed, and processed agricultural products.",
    "DTN Network: Digital Transformation Network (DTN) is a platform designed to help agribusinesses manage and grow investable assets through digital tools. It enables data-driven investment planning, asset tracking, and performance optimization across agricultural operations.    ",
  ];

  const data2 = [
    "AI/ML App: AI/ML App for Agribusiness uses artificial intelligence to provide real-time insights like crop yield prediction, market price forecasting, and pest detection. It helps farmers and agribusinesses make smarter, data-driven decisions to boost productivity and profits.    ",
  ];
  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="solution-marketplace-bg"
        bannerTitle={["pointSolutions"]}
        bannerbodycopy=" AI/ML Apps "
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="pSolutionMarketplace" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features & Benefits Section */}
      <SolutionMarketplaceFeatures />
      <SolutionMarketplacebenefits />
    </>
  );
}
